// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Delete Modal Container */
.delete_deleteModal__-fpYt {
    margin: 16px !important;
  }
  
  .delete_deleteModal__-fpYt .MuiDialog-paper {
    margin: 16px !important;
    width: 100% !important;
    max-width: 540px !important;
    border-radius: 12px !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    border: 1px solid #e5e7eb !important;
  }
  
  /* Modal Header */
  .delete_modalHeader__NpFCg {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding-bottom: 8px !important;
    border-bottom: 1px solid #f3f4f6 !important;
  }
  
  .delete_modalTitle__NPkfp {
  
    color: var(--Slate-700, #334155);
  
  /* Inter/Body xl/Body xl - semibold */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
  }
  
  .delete_closeButton__uv0-V {
    color: #6b7280 !important;
  }
  
  .delete_closeButton__uv0-V:hover {
    background-color: #f3f4f6 !important;
  }
  
  /* Modal Content */
  .delete_modalContent__uXEF8 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  
  .delete_confirmationText__QRT4X {
      color: var(--Slate-800, #1E293B);
  
      /* Inter/Body md/Body md - medium */
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
  }
  
  .delete_warningText__j1jk4 {
      color: var(--Slate-500, #64748B);
  
      /* text-sm/leading-5/normal */
      font-family: var(--font-family-font-sans, Inter);
      font-size: text-sm;
      font-style: normal;
      font-weight: var(--font-weight-font-normal, 400);
      line-height: leading-5; /* 142.857% */
  }
  
  /* Modal Actions */
  .delete_modalActions__T9M0U {
    padding: 24px 32px !important;
    /* padding-top: 8px !important; */
    border-top: 1px solid #f3f4f6 !important;
    gap: 16px !important;
  }
  
  /* Cancel Button */
  .delete_cancelButton__Hkzt8 {
  border: none !important;
    color: #374151 !important;
    text-transform: none !important;
    font-weight: 500 !important;
    padding: 7px 24px !important;
    border-radius: 8px !important;
    background-color: rgba(241, 245, 249, 1) !important;
  }
  
  .delete_cancelButton__Hkzt8:hover {
    border-color: #9ca3af !important;
    background-color: #e5e7eb !important;
  }
  
  /* Delete Button */
  .delete_deleteButton__Iu44p {
    background-color: rgba(220, 38, 38, 1) !important;
    text-transform: none !important;
    font-weight: 500 !important;
    padding: 7px 24px !important;
    border-radius: 8px !important;
    box-shadow: none !important;
  }
  
  .delete_deleteButton__Iu44p:hover {
    background-color: rgba(200, 38, 38, 1) !important;
    box-shadow: none !important;
  }
  
  /* Delete Icon */
  .delete_deleteIcon__gFRDC {
    color: white !important;
  }
  
  /* Responsive adjustments */
  @media (max-width: 600px) {
    .delete_deleteModal__-fpYt .MuiDialog-paper {
      margin: 8px !important;
      max-width: calc(100vw - 16px) !important;
    }
    
    .delete_modalActions__T9M0U {
      padding: 8px 16px 16px 16px !important;
      gap: 12px !important;
    }
    
    .delete_cancelButton__Hkzt8,
    .delete_deleteButton__Iu44p {
      padding: 10px 20px !important;
    }
  } `, "",{"version":3,"sources":["webpack://./src/views/StudentGatePass/components/delete.module.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,8BAA8B;IAC9B,gGAAgG;IAChG,oCAAoC;EACtC;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,8BAA8B;IAC9B,2CAA2C;EAC7C;;EAEA;;IAEE,gCAAgC;;EAElC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC;;EAEA,kBAAkB;EAClB;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;MACI,gCAAgC;;MAEhC,mCAAmC;MACnC,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAE,SAAS;EAChC;;EAEA;MACI,gCAAgC;;MAEhC,6BAA6B;MAC7B,gDAAgD;MAChD,kBAAkB;MAClB,kBAAkB;MAClB,gDAAgD;MAChD,sBAAsB,EAAE,aAAa;EACzC;;EAEA,kBAAkB;EAClB;IACE,6BAA6B;IAC7B,iCAAiC;IACjC,wCAAwC;IACxC,oBAAoB;EACtB;;EAEA,kBAAkB;EAClB;EACA,uBAAuB;IACrB,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,mDAAmD;EACrD;;EAEA;IACE,gCAAgC;IAChC,oCAAoC;EACtC;;EAEA,kBAAkB;EAClB;IACE,iDAAiD;IACjD,+BAA+B;IAC/B,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,iDAAiD;IACjD,2BAA2B;EAC7B;;EAEA,gBAAgB;EAChB;IACE,uBAAuB;EACzB;;EAEA,2BAA2B;EAC3B;IACE;MACE,sBAAsB;MACtB,wCAAwC;IAC1C;;IAEA;MACE,sCAAsC;MACtC,oBAAoB;IACtB;;IAEA;;MAEE,6BAA6B;IAC/B;EACF","sourcesContent":["/* Delete Modal Container */\n.deleteModal {\n    margin: 16px !important;\n  }\n  \n  .deleteModal :global(.MuiDialog-paper) {\n    margin: 16px !important;\n    width: 100% !important;\n    max-width: 540px !important;\n    border-radius: 12px !important;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;\n    border: 1px solid #e5e7eb !important;\n  }\n  \n  /* Modal Header */\n  .modalHeader {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding-bottom: 8px !important;\n    border-bottom: 1px solid #f3f4f6 !important;\n  }\n  \n  .modalTitle {\n  \n    color: var(--Slate-700, #334155);\n  \n  /* Inter/Body xl/Body xl - semibold */\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px; /* 150% */\n  }\n  \n  .closeButton {\n    color: #6b7280 !important;\n  }\n  \n  .closeButton:hover {\n    background-color: #f3f4f6 !important;\n  }\n  \n  /* Modal Content */\n  .modalContent {\n    padding-top: 24px !important;\n    padding-bottom: 24px !important;\n  }\n  \n  .confirmationText {\n      color: var(--Slate-800, #1E293B);\n  \n      /* Inter/Body md/Body md - medium */\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 24px; /* 150% */\n  }\n  \n  .warningText {\n      color: var(--Slate-500, #64748B);\n  \n      /* text-sm/leading-5/normal */\n      font-family: var(--font-family-font-sans, Inter);\n      font-size: text-sm;\n      font-style: normal;\n      font-weight: var(--font-weight-font-normal, 400);\n      line-height: leading-5; /* 142.857% */\n  }\n  \n  /* Modal Actions */\n  .modalActions {\n    padding: 24px 32px !important;\n    /* padding-top: 8px !important; */\n    border-top: 1px solid #f3f4f6 !important;\n    gap: 16px !important;\n  }\n  \n  /* Cancel Button */\n  .cancelButton {\n  border: none !important;\n    color: #374151 !important;\n    text-transform: none !important;\n    font-weight: 500 !important;\n    padding: 7px 24px !important;\n    border-radius: 8px !important;\n    background-color: rgba(241, 245, 249, 1) !important;\n  }\n  \n  .cancelButton:hover {\n    border-color: #9ca3af !important;\n    background-color: #e5e7eb !important;\n  }\n  \n  /* Delete Button */\n  .deleteButton {\n    background-color: rgba(220, 38, 38, 1) !important;\n    text-transform: none !important;\n    font-weight: 500 !important;\n    padding: 7px 24px !important;\n    border-radius: 8px !important;\n    box-shadow: none !important;\n  }\n  \n  .deleteButton:hover {\n    background-color: rgba(200, 38, 38, 1) !important;\n    box-shadow: none !important;\n  }\n  \n  /* Delete Icon */\n  .deleteIcon {\n    color: white !important;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 600px) {\n    .deleteModal :global(.MuiDialog-paper) {\n      margin: 8px !important;\n      max-width: calc(100vw - 16px) !important;\n    }\n    \n    .modalActions {\n      padding: 8px 16px 16px 16px !important;\n      gap: 12px !important;\n    }\n    \n    .cancelButton,\n    .deleteButton {\n      padding: 10px 20px !important;\n    }\n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteModal": `delete_deleteModal__-fpYt`,
	"modalHeader": `delete_modalHeader__NpFCg`,
	"modalTitle": `delete_modalTitle__NPkfp`,
	"closeButton": `delete_closeButton__uv0-V`,
	"modalContent": `delete_modalContent__uXEF8`,
	"confirmationText": `delete_confirmationText__QRT4X`,
	"warningText": `delete_warningText__j1jk4`,
	"modalActions": `delete_modalActions__T9M0U`,
	"cancelButton": `delete_cancelButton__Hkzt8`,
	"deleteButton": `delete_deleteButton__Iu44p`,
	"deleteIcon": `delete_deleteIcon__gFRDC`
};
export default ___CSS_LOADER_EXPORT___;
